import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import DocumentTitle from 'utils/DocumentTitle';
import {
  dataRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';
import Content from './Content';
import LargePreLoader from '../../../../../components/Common/PreLoaders/LargePreLoader';

const usersCollectionRName = 'usersModule.collections.userCollection';

class UserProfileReduceWrapper extends Component {
  constructor(props) {
    super(props);
    this.props.dataRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.userId !== this.props.match.params.userId) {
      this.props.dataRequest();
    }
  }

  render() {
    if (this.props.requestState.requestInProcess) {
      return <LargePreLoader />;
    } else if (this.props.userInfo) {
      return (
        <DocumentTitle title={this.props.userInfo.username}>
          <Content {...this.props} />
        </DocumentTitle>
      );
    }
    return null;
  }
}

UserProfileReduceWrapper.defaultProps = {
  userInfo: null
};

UserProfileReduceWrapper.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,

  // CONNECT
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired,
    lastStatusCode: PropTypes.number
  }).isRequired,
  userInfo: PropTypes.shape({
    username: PropTypes.string.isRequired
  }),
  dataRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestsStateById(
    state,
    usersCollectionRName,
    props.match.params.userId
  ),
  userInfo: selectItemById(
    state,
    usersCollectionRName,
    props.match.params.userId
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequest: () =>
    dispatch(dataRequest(usersCollectionRName, props.match.params.userId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserProfileReduceWrapper)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/index.js